module.exports = __webpack_public_path__ + "img/10a.03dc9bc0.svg";